import { BiSearch } from 'react-icons/bi';
import { FaRegBell } from 'react-icons/fa6';

import ActiveTasksIndicator from '@/components/ActiveTasksIndicator/ActiveTasksIndicator';
import { SEARCH_HOTKEY_LABEL, SEARCH_HOTKEY_SPOKEN } from '@/components/GlobalSearch';
import { useNotificationsPanel } from '@/hooks/useNotificationsPanel';
import { useGlobalSearchStore } from '@/store/global-search/global-search.store';
import { useNotificationContext } from '@/store/notifications/use-notifications-context';

import { DesktopHeaderAccountSwitch } from './DesktopHeaderAccountSwitch';
import s from './DesktopHeaderUserArea.module.scss';

export const DesktopHeaderUserArea = () => {
  const { unreadCount } = useNotificationContext();
  const { open: openNotificationsPanel } = useNotificationsPanel();
  const openSearch = useGlobalSearchStore((st) => st.open);

  return (
    <div className={s.root}>
      <ActiveTasksIndicator />
      <div className={s.utilities}>
        <button
          type="button"
          className={s.iconBtn}
          aria-label={`Search (${SEARCH_HOTKEY_SPOKEN})`}
          title={`Search (${SEARCH_HOTKEY_LABEL})`}
          onClick={openSearch}
        >
          <BiSearch />
        </button>
        <button
          type="button"
          className={s.iconBtn}
          aria-label="Notifications"
          onClick={openNotificationsPanel}
        >
          <span className={s.bellWrap}>
            <FaRegBell />
            {unreadCount > 0 && <span className={s.badge}>{unreadCount}</span>}
          </span>
        </button>
      </div>
      <DesktopHeaderAccountSwitch />
    </div>
  );
};
